<span class="supplier-cell" (click)="openDialog()" [matTooltip]="params.value">
    {{ supplierCodes }}
  </span>